module.exports = __webpack_public_path__ + "static/img/zwlstp.0c2916ae.png";